
import {
  Form,
  Input,
  Checkbox,
  Button,
  FormItem,
  Select,
  Option,
  CollapseTransition,
  OptionGroup,
} from 'element-ui';
import { ChevronDownIcon } from 'vue-feather-icons';
import { AddressHelpers } from '@/helpers/AddressHelpers';
import addressMixin from '@/mixins/addressMixin';

export default {
  props: {
    idAddress: {
      type: String | Number,
      default: null,
    },
  },
  mixins: [addressMixin],
  data() {
    this.setCustomerConected();
    return {
      customer: null,
      openAdd: false,
      showAddressLine2: false,
      addressInfo: {
        Alias: '',
        Lastname: this.customer?.Lastname,
        Firstname: this.customer?.Firstname,
        Address1: '',
        Address2: '',
        Postcode: '',
        City: '',
        CountryIsoCode: '',
        MobilePhoneCode: '+33',
        MobilePhone: '',
        PhoneCode: '+33',
        Phone: '',
        Company: '',
        IsInvoice: true,
        IsDelivery: true,
      },
      rules: {
        MobilePhone: [
          {
            required: true,
            message: this.$t('Required Field'),
            trigger: 'blur',
          },
        ],
      },
      clientCountry: null,
    };
  },
  computed: {
    countries() {
      return this.$localisation.countries;
    },
    getClientCountry() {
      return this.$localisation.countries.find(
        (country) => country?.CountryIsoCode === this.clientCountry?.country
      );
    },
  },
  async mounted() {
    // if (this.address != null) {
    //   this.addressInfo = this.address;
    // }
    try {
      await this.loadClientCountryIsoCode();
    } catch (error) {}

    if (process.client) {
      if (this.$route.hash === '#mobilephone') {
        const field = this.$refs?.mobilePhone.$el.querySelector('input');
        field.focus();
        this.scrollTo(field);
      }
    }

    if (this.idAddress) {
      const listAddress = this.$store.state.address.List;

      if (listAddress.length === 0) {
        await this.getAddresses();
      }
      const idAddress = this.idAddress;
      const address = this.$store.state.address.List.filter((item) => {
        return Number(item.IdAddress) === Number(idAddress);
      })[0];

      // Process the address to extract phone codes if they exist
      const processedAddress = { ...address };

      // Extract mobile phone code if it exists
      if (processedAddress.MobilePhone) {
        const mobileMatch = processedAddress.MobilePhone.split(' ');
        if (mobileMatch.length === 2) {
          processedAddress.MobilePhoneCode = mobileMatch[0];
          processedAddress.MobilePhone = mobileMatch[1];
        } else if (mobileMatch.length === 1) {
          processedAddress.MobilePhone = mobileMatch[0];
          processedAddress.MobilePhoneCode = '+33'; // Default code
        }
      }

      // Extract phone code if it exists
      if (processedAddress.Phone) {
        const phoneMatch = processedAddress.Phone.split(' ');
        if (phoneMatch.length === 2) {
          processedAddress.PhoneCode = phoneMatch[0];
          processedAddress.Phone = phoneMatch[1];
        } else if (phoneMatch.length === 1) {
          processedAddress.Phone = phoneMatch[0];
          processedAddress.PhoneCode = '+33'; // Default code
        }
      }

      this.addressInfo = { ...processedAddress };
    } else {
      this.addressInfo.CountryIsoCode =
        this.getClientCountry?.CountryIsoCode || '';
    }
    setTimeout(() => {
      this.openAdd = true;
    }, 100);
  },
  methods: {

    scrollTo(element) {
      const y = element.getBoundingClientRect().top + window.scrollY - 160; // Added 80px offset for better visibility
      window.scrollTo({
        top: y,
        behavior: 'smooth',
      });
    },
    setCustomerConected() {
      let userGuest = this.$store.state.user.guest.guestUser;

      if (this.$auth.loggedIn) {
        this.customer = this.$auth.user.Customer;
      } else if (userGuest) {
        this.customer = userGuest;
      }
    },

    async submitForm() {
      this.$refs['AddressForm'].validate(async (valid) => {
        if (valid) {
          if (this.idAddress) {
            await this.updateAddress(this.idAddress);
          } else {
            await this.createAddress();
          }
        } else {
          // Find the first field with error and scroll to it
          this.$nextTick(() => {
            const errorField = document.querySelector('.el-form-item.is-error');
            if (errorField) {
              this.scrollTo(errorField);
            }
          });
          return false;
        }
      });
    },


    updateAddress(idAddress) {
      this.addressService
        .update(idAddress, this.addressInfo)
        .then((data) => {
          this.addressService.fetchAddresses({
            onSuccess: () => {
              this.$emit('onSubmit', data);
            },
          });
        })
        .catch((err) => {});
    },



    async getAddresses() {
      const addressHelpers = new AddressHelpers(this.$http, this.$store);
      await addressHelpers.getList();
    },

    async loadClientCountryIsoCode() {
      try {
        const res = await this.$axios.$get('/api/visitor');
        // Example output: { ip: "8.8.8.8", country: "US" }
        this.clientCountry = res;
      } catch (e) {
        console.error('Failed to fetch visitor info', e);
      }
    },
  },
  components: {
    Form,
    Input,
    Checkbox,
    Button,
    FormItem,
    Select,
    Option,
    OptionGroup,
    CollapseTransition,
    ChevronDownIcon,
  },
};
